import { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import CheckMark from '../../images/check-mark.svg';
import Trash from '../../images/large-trash.svg';
import { useUserState } from './UserStateProvider';

const ConfirmationModal = ({
    show,
    changeVisibility,
    type,
    confirmationButton,
    confirmationMessage,
    successMessage,
    modalFunction,
    close,
    closeConfirmation,
    error
}) => {
    const [confirmed, setConfirmed] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const { theme } = useUserState();

    const handleConfirmation = async () => {
        const result = await modalFunction();
        setConfirmed(true);
        setIsSuccess(result);
    };

    const handleModalExited = () => {
        setConfirmed(false);
        setIsSuccess(false);
    };

    const renderHeaderImage = () => {
        if (type === 'success') {
            return <img src={CheckMark} className="confirmation-img tif-mb-md-55 tif-mb-30" alt="Check mark" />;
        } else if (type === 'delete') {
            return <img src={Trash} className="confirmation-img tif-mb-md-90 tif-mb-40" alt="Trash Can" />;
        }
        return null;
    };

    return (
        <Modal className={`confirmation-modal ${theme === 'light' ? 'light-mode' : ''}`} show={show} onHide={() => changeVisibility(false)} onExited={handleModalExited} backdrop="static">
            <Modal.Header>{renderHeaderImage()}</Modal.Header>
            <Modal.Body>
                {confirmationButton && !confirmed && (
                    <div>
                        <h2 className="tif-light-color-november">{confirmationMessage}</h2>
                        { error && <p className="error-text tif-mb-5">{ error }</p> }
                        <Button className="dashboard-quarternary-btn tif-mt-35" onClick={handleConfirmation}>{confirmationButton}</Button>
                    </div>
                )}
                {((confirmed && isSuccess) || type === 'success') && 
                    <div>
                        <h2 className="tif-light-color-november">{successMessage}</h2>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer>
                {closeConfirmation && confirmed ? closeConfirmation : close}
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
